import { render, staticRenderFns } from "./OrdersWaiting.vue?vue&type=template&id=34ba661e&scoped=true"
import script from "./OrdersWaiting.vue?vue&type=script&lang=js"
export * from "./OrdersWaiting.vue?vue&type=script&lang=js"
import style0 from "./OrdersWaiting.vue?vue&type=style&index=0&id=34ba661e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ba661e",
  null
  
)

export default component.exports